module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/ch/irole.png
// module id = lEEd
// module chunks = 7